import React, { useEffect, useState } from "react";
import InvoiceTable from "./InvoiceTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getInvoices } from "../../redux//actions/invoiceAction";

const Inovices = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getInvoices(setLoading));
    }, [dispatch]);

    let allInvoice = useSelector((state) => state.invoice.allInvoice);

    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            // Match the fields the table actually renders; `amount` was never a
            // field on these rows (the amount lives in `amountPaid`).
            const term = search.toLowerCase();
            data = data?.filter(
                (item) =>
                    item?.invoice?.id?.toLowerCase().includes(term) ||
                    item?.user?.firstName?.toLowerCase().includes(term) ||
                    item?.user?.lastName?.toLowerCase().includes(term) ||
                    item?.planDetails?.name?.toLowerCase().includes(term) ||
                    String(item?.amountPaid ?? "").includes(term)
            );
        }
        return data;
    };

    allInvoice = getFilteredData(allInvoice, search);
    allInvoice = allInvoice.map((item) => ({
        ...item,
        time: new Date(item.time),
    }));

    return <InvoiceTable heading="All invoice" allInvoice={allInvoice} loading={loading} history={history} search={search} setSearch={setSearch}  />;
};

export default Inovices;
